import React from "react";

export default class DefaultLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: undefined,
      isLoading: true,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.group_ids !== prevProps.group_ids ||
      this.props.group_categories !== prevProps.group_categories ||
      this.props.resident_statuses !== prevProps.resident_statuses ||
      this.props.start_date !== prevProps.start_date ||
      this.props.end_date !== prevProps.end_date ||
      this.props.therapist !== prevProps.therapist ||
      this.props.slug !== prevProps.slug ||
      this.props.resident_id !== prevProps.resident_id
    ) {
      this.fetchData();
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    this.setState({ isLoading: true, processing: true });
    const {
      organization_name,
      metric,
      group_ids,
      group_categories,
      start_date,
      end_date,
      therapist,
      resident_statuses,
      resident_id,
    } = this.props;
    let therapistFilter = therapist
      ? `&therapist=${therapist}`
      : "&therapist=all";
    const residentFilter = resident_id ? `&resident_id=${resident_id}` : "";
    let url =
      `/organizations/${organization_name}/outcomes/${metric.endpoint}.json?slug=${metric.slug}&demographic=${metric.demographic}&group_ids=${group_ids}&start_date=${start_date}&end_date=${end_date}&group_categories=${group_categories}&resident_statuses=${resident_statuses}${residentFilter}` +
      therapistFilter;
    $.ajax({ url }).then((response) => {
      this.setState((prevState, props) => {
        return {
          isLoading: false,
          data: response.data,
          processing: false,
        };
      });
    });
  }
}
